import React from 'react';
import PropTypes from 'prop-types';
import { TimePicker } from 'antd';
import moment from 'moment';
import 'moment/locale/fr';


const CustomTimePicker = (props) => {
    const onBlur = (elem) => {
        const value = moment(elem.target.value, props.format);
        if (value && value.isValid() && props.onChange) {
            props.onChange(value, elem.target.value);
        }
    };
    return <TimePicker {...props} onBlur={onBlur} />;
};

CustomTimePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    format: PropTypes.string.isRequired,
};


export default CustomTimePicker;
